const ObjectModifier = (obj) => {
  let myObj = {};
  for (const [name, value] of Object.entries(obj)) {
    const splitKeyName = name.split(".");
    const configName = splitKeyName[0];
    const keyName = splitKeyName[1];

    myObj = {
      ...myObj,
      [configName]: {
        ...myObj[configName],
        [keyName]: value,
        // Name is to keep it Tagged
        name: configName,
      },
    };
  }
  return myObj;
};

export default ObjectModifier;
